import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useModal,
  useLikeWatchLater,
  useHistory,
  usePlaylist,
  useAuth,
  useVideo,
} from "../../context";
import { MdPlaylistAdd } from "react-icons/md";
import { FiTrash2 } from "react-icons/fi";

import "./videoCard.css";

export const VideoCard = ({
  video,
  avatar,
  isExplore = false,
  isLike = false,
  isWatchLater = false,
  isHistory = false,
  playlistId = "",
  isPlaylist = false,
  isProfile = false,
}) => {
  let navigate = useNavigate();
  const { deleteVideoHandler } = useVideo();
  const { addToWatchLater, handleLike } = useLikeWatchLater();
  const { removeFromHistory } = useHistory();
  const { setSelectedVideo, deleteFromPlaylist } = usePlaylist();
  const { encodedToken } = useAuth();
  const { setIsModal } = useModal();
  const clickHandler = (video) => {
    if (!encodedToken) navigate("../login", { replace: true });
    else {
      setIsModal((prev) => !prev);
      setSelectedVideo(video);
    }
  };
  const removeVideoFromDBHandler = (id) => {
    deleteVideoHandler(id);
  };
  return (
    <>
      {video && (
        <div className="video-card margin-xs padding-xs">
          <Link to={`/video/${video?._id}`} state={video}>
            <div className="img-container">
              <img
                loading="lazy"
                className="img-responsive"
                src={video?.thumbnail}
                alt="video_thumbnail"
              />
            </div>
          </Link>
          <div className="video-info-container">
            <div className="avatar avatar-xs">
              <img
                loading="lazy"
                className="img-responsive img-round"
                src={video?.ownerDetails?.avatar || avatar}
                alt="avatar"
              />
            </div>
            <h4 className="video-title text-center">{video?.title}</h4>
            {isPlaylist && (
              <button
                className="remove-btn"
                onClick={() => deleteFromPlaylist(playlistId, video?._id)}
              >
                <FiTrash2 className="trash-icon" />
              </button>
            )}
            {isExplore && (
              <button
                onClick={() => clickHandler(video)}
                className="playlist-btn"
              >
                <MdPlaylistAdd className="playlist-icon" />
              </button>
            )}
            {isWatchLater && (
              <button
                className="remove-btn"
                onClick={() => addToWatchLater(video?._id)}
              >
                <FiTrash2 className="trash-icon" />
              </button>
            )}
            {isLike && (
              <button
                className="remove-btn"
                onClick={() => handleLike(video?._id)}
              >
                <FiTrash2 className="trash-icon" />
              </button>
            )}
            {isHistory && (
              <button
                className="remove-btn"
                onClick={() => removeFromHistory(video?._id)}
              >
                <FiTrash2 className="trash-icon" />
              </button>
            )}
            {isProfile && (
              <button
                className="remove-btn"
                onClick={() => removeVideoFromDBHandler(video?._id)}
              >
                <FiTrash2 className="trash-icon" />
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};
